var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsNotificationActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16.746 16.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "notifications-active-svgrepo-com",
    d: "M10.623,5.118a4.235,4.235,0,0,1,4.235,4.235v1.9a1.694,1.694,0,0,0,.428,1.125l1.081,1.216a1.27,1.27,0,0,1-.95,2.115H5.829a1.27,1.27,0,0,1-.95-2.115l1.08-1.216a1.694,1.694,0,0,0,.428-1.125v-1.9A4.235,4.235,0,0,1,10.623,5.118Zm0,0V3M3,9.776A7.616,7.616,0,0,1,6.388,3.437M18.246,9.776a7.616,7.616,0,0,0-3.388-6.339M9.776,18.246H11.47",
    transform: "translate(-2.25 -2.25)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsNotificationActiveIcon);
export default __webpack_public_path__ + "static/media/settings-notification-active-icon.90f98ff5dc79eafde9f0fde00be5e461.svg";
export { ForwardRef as ReactComponent };